export const routes = [
    {
        context: 'platform',
        method: 'GET',
        path: '/admins',
        operationId: 'Admins_list',
        auth: 'platform-admin',
        action: 'admin:list',
        tool: 'platform_Admins_list',
        description: 'Platform-staff users of the control-plane pool.',
        pathParams: [],
        queryParams: ['cursor', 'limit'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/admins',
        operationId: 'Admins_create',
        auth: 'platform-admin',
        action: 'admin:create',
        tool: 'platform_Admins_create',
        description: 'Invite a platform-staff user: creates them in the control-plane pool (TOTP required at first sign-in).',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'platform',
        method: 'DELETE',
        path: '/admins/{sub}',
        operationId: 'Admins_remove',
        auth: 'platform-admin',
        action: 'admin:remove',
        tool: 'platform_Admins_remove',
        description: 'Remove a platform-staff user. Never oneself.',
        pathParams: ['sub'],
        queryParams: [],
        hasBody: false,
        successStatus: 204,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/admins/{sub}',
        operationId: 'Admins_get',
        auth: 'platform-admin',
        action: 'admin:read',
        tool: 'platform_Admins_get',
        description: 'One platform-staff user.',
        pathParams: ['sub'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/announcements',
        operationId: 'Announcements_list',
        auth: 'platform-admin',
        action: 'announcement:list',
        tool: 'platform_Announcements_list',
        description: 'Announcements, newest first.',
        pathParams: [],
        queryParams: ['cursor', 'limit'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/announcements',
        operationId: 'Announcements_publish',
        auth: 'platform-admin',
        action: 'announcement:publish',
        tool: 'platform_Announcements_publish',
        description: "Show a notice to the people of a tenant, one person, or every active tenant of a cell. Sent\nto each tenant's cell; audited on each tenant's log.",
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/announcements/{announcementId}/withdraw',
        operationId: 'Announcements_withdraw',
        auth: 'platform-admin',
        action: 'announcement:withdraw',
        tool: 'platform_Announcements_withdraw',
        description: 'Take an announcement back: the apps stop showing it. Idempotent.',
        pathParams: ['announcementId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/cells',
        operationId: 'Cells_list',
        auth: 'platform-admin',
        action: 'cell:list',
        tool: 'platform_Cells_list',
        description: 'Every cell the directory routes to, with hostnames and tenant counts.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/directory/{slug}',
        operationId: 'Directory_get',
        auth: 'public',
        action: 'directory:read',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'Where a workspace lives: its cell and app hostname. 404 until the tenant is provisioned.',
        pathParams: ['slug'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/menu',
        operationId: 'Menu_get',
        auth: 'platform-admin',
        action: 'menu:read',
        tool: 'platform_Menu_get',
        description: 'The platform menu definition: every item with the action and feature that gate it.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/metering',
        operationId: 'Metering_ingest',
        auth: 'platform-admin',
        action: 'metering:ingest',
        tool: 'platform_Metering_ingest',
        description: 'Ingest usage records for a tenant (stub: stored, not yet aggregated). Cells use the bus.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/metering/usage',
        operationId: 'Metering_usage',
        auth: 'platform-admin',
        action: 'metering:read',
        tool: 'platform_Metering_usage',
        description: 'Usage per tenant over one UTC month or day, summed per metric; `tenantId` narrows it to one tenant.',
        pathParams: [],
        queryParams: ['cursor', 'limit', 'period', 'tenantId'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/packages',
        operationId: 'Packages_list',
        auth: 'platform-admin',
        action: 'package:list',
        tool: 'platform_Packages_list',
        description: 'List catalog packages, retired ones included when asked.',
        pathParams: [],
        queryParams: ['cursor', 'limit', 'includeRetired'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/packages',
        operationId: 'Packages_create',
        auth: 'platform-admin',
        action: 'package:create',
        tool: 'platform_Packages_create',
        description: 'Create a package at version 1.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/packages/{packageId}',
        operationId: 'Packages_get',
        auth: 'platform-admin',
        action: 'package:read',
        tool: 'platform_Packages_get',
        description: 'Read a package at its current version.',
        pathParams: ['packageId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'PATCH',
        path: '/packages/{packageId}',
        operationId: 'Packages_update',
        auth: 'platform-admin',
        action: 'package:update',
        tool: 'platform_Packages_update',
        description: 'Edit a package. Bumps `version`; no tenant snapshot changes.',
        pathParams: ['packageId'],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/packages/{packageId}/retire',
        operationId: 'Packages_retire',
        auth: 'platform-admin',
        action: 'package:retire',
        tool: 'platform_Packages_retire',
        description: 'Retire a package: no new adoptions. Existing snapshots are untouched.',
        pathParams: ['packageId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/products',
        operationId: 'Products_list',
        auth: 'platform-admin',
        action: 'product:list',
        tool: 'platform_Products_list',
        description: 'Every product the platform sells, one per `products/<name>/product.yaml`.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/signup',
        operationId: 'Signup_request',
        auth: 'public',
        action: 'signup:create',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'Self-serve signup: reserves the slug and starts onboarding (pay first, then provision).',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/signup/availability',
        operationId: 'Signup_availability',
        auth: 'public',
        action: 'signup:read',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'Is this slug free?',
        pathParams: [],
        queryParams: ['slug'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/signup/catalog',
        operationId: 'Signup_catalog',
        auth: 'public',
        action: 'signup:read',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'Packages a self-serve visitor of one product may pick: pool tier, not retired. No prices\n(Checkout carries them). `product` absent reads as `sprocket` until every sign-up page sends it.',
        pathParams: [],
        queryParams: ['product'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/signup/documents',
        operationId: 'Signup_documents',
        auth: 'public',
        action: 'signup:read',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'The documents a person accepts to sign up for one product, at their current versions, with\nwhere to read them. Empty: the product asks for none.',
        pathParams: [],
        queryParams: ['product'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/signup/personal',
        operationId: 'Signup_personal',
        auth: 'public',
        action: 'signup:create',
        assistantExempt: 'public endpoint; the caller is a person without a tenant yet',
        description: "Personal sign-up: the caller has already created and confirmed their identity in a cell pool\nof the package's product and presents its ID token as `Authorization: Bearer`; the handler\nverifies it against the directory's cell issuers (the gateway does not). Starts the same\npay-first onboarding as `request`. The tenant id is derived from the product and the\nperson, so a repeat resumes it. Poll with `status` using the returned `slug`.",
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/signup/status',
        operationId: 'Signup_status',
        auth: 'public',
        action: 'signup:read',
        assistantExempt: 'public endpoint; there is no principal to act as',
        description: 'Poll onboarding progress for a slug. Reveals status only, never tenant data.',
        pathParams: [],
        queryParams: ['slug'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/tenants',
        operationId: 'Tenants_list',
        auth: 'platform-admin',
        action: 'tenant:list',
        tool: 'platform_Tenants_list',
        description: 'List tenants in the registry.',
        pathParams: [],
        queryParams: ['cursor', 'limit', 'status'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants',
        operationId: 'Tenants_create',
        auth: 'platform-admin',
        action: 'tenant:create',
        tool: 'platform_Tenants_create',
        description: 'Onboard a tenant (sales-led). Starts the onboarding workflow; returns 202 with the registry entry in `pendingPayment`.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/tenants/{tenantId}',
        operationId: 'Tenants_get',
        auth: 'platform-admin',
        action: 'tenant:read',
        tool: 'platform_Tenants_get',
        description: 'Read one tenant registry entry, including its entitlement snapshot.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'PATCH',
        path: '/tenants/{tenantId}',
        operationId: 'Tenants_update',
        auth: 'platform-admin',
        action: 'tenant:update',
        tool: 'platform_Tenants_update',
        description: 'Update name or flags. Tier, package and status have their own operations.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/offboard',
        operationId: 'Tenants_offboard',
        auth: 'platform-admin',
        action: 'tenant:offboard',
        tool: 'platform_Tenants_offboard',
        description: 'Start offboarding. Data is retained per the retention policy until deprovisioning completes.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/tenants/{tenantId}/onboarding',
        operationId: 'Tenants_onboarding',
        auth: 'platform-admin',
        action: 'tenant:read',
        tool: 'platform_Tenants_onboarding',
        description: "The onboarding workflow's state for a tenant: stage, attempt, execution, checkout, failure.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/package',
        operationId: 'Tenants_adoptPackage',
        auth: 'platform-admin',
        action: 'tenant:adopt-package',
        tool: 'platform_Tenants_adoptPackage',
        description: "Adopt a package: snapshots the package's current version onto the tenant.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/package/reapply',
        operationId: 'Tenants_reapplyPackage',
        auth: 'platform-admin',
        action: 'tenant:reapply-package',
        tool: 'platform_Tenants_reapplyPackage',
        description: "Re-apply the tenant's package: replaces the snapshot with the package's current version.\nThe only way a catalog edit reaches a tenant. Explicit, audited, never implicit.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/resume',
        operationId: 'Tenants_resume',
        auth: 'platform-admin',
        action: 'tenant:resume',
        tool: 'platform_Tenants_resume',
        description: 'Lift a suspension.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/retry',
        operationId: 'Tenants_retry',
        auth: 'platform-admin',
        action: 'tenant:retry',
        tool: 'platform_Tenants_retry',
        description: 'Retry a failed onboarding: starts a new workflow attempt. 409 unless the tenant is `failed`.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/suspend',
        operationId: 'Tenants_suspend',
        auth: 'platform-admin',
        action: 'tenant:suspend',
        tool: 'platform_Tenants_suspend',
        description: 'Suspend sign-in for every user of the tenant. Data is untouched.',
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/tenants/{tenantId}/tier',
        operationId: 'Tenants_changeTier',
        auth: 'platform-admin',
        action: 'tenant:change-tier',
        tool: 'platform_Tenants_changeTier',
        description: "Change the tenant's tier. Moving to silo starts a cell provisioning job; returns 202.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: true,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/tiers',
        operationId: 'Tiers_list',
        auth: 'platform-admin',
        action: 'tier:list',
        tool: 'platform_Tiers_list',
        description: 'The tiers this cell offers and their limits.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/workspace',
        operationId: 'Workspaces_get',
        auth: 'tenant',
        action: 'workspace:read',
        tool: 'platform_Workspaces_get',
        description: "The caller's own workspace: name, tier, status, entitlement.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/workspace/catalog',
        operationId: 'Workspaces_catalog',
        auth: 'tenant',
        action: 'catalog:read',
        tool: 'platform_Workspaces_catalog',
        description: "Packages the caller's tenant could adopt (its tier, not retired).",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'DELETE',
        path: '/workspace/deletion',
        operationId: 'WorkspaceDeletions_cancel',
        auth: 'tenant',
        action: 'deletion:cancel',
        assistantExempt: 'the person withdraws their own request',
        description: 'Withdraw a scheduled deletion. 404 when none is scheduled, 409 once its date has passed.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 204,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/workspace/deletion',
        operationId: 'WorkspaceDeletions_request',
        auth: 'tenant',
        action: 'deletion:request',
        assistantExempt: 'irreversible after 30 days: only the person themselves asks for it',
        description: 'Schedule the deletion of the tenant and everything it holds, 30 days from now. Idempotent.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/workspace/entitlement',
        operationId: 'Workspaces_entitlement',
        auth: 'tenant',
        action: 'entitlement:read',
        tool: 'platform_Workspaces_entitlement',
        description: "The caller's entitlement snapshot. What the app gates features on.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'platform',
        method: 'POST',
        path: '/workspace/exports',
        operationId: 'WorkspaceExports_create',
        auth: 'tenant',
        action: 'export:create',
        assistantExempt: "the archive holds the tenant's whole record; a person asks for it themselves",
        description: 'Ask for an export of everything the tenant holds. 409 while another one is being prepared.',
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 202,
    },
    {
        context: 'platform',
        method: 'GET',
        path: '/workspace/exports/{exportId}',
        operationId: 'WorkspaceExports_get',
        auth: 'tenant',
        action: 'export:read',
        assistantExempt: 'the download link is for the person who asked, never for a model',
        description: 'Where an export is; when ready, a download link valid for a few minutes.',
        pathParams: ['exportId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map